import { RatePlanPolicy } from '../../types/rateplanPolicy'
import PolicyRowSkeleton from './RatePlanPolicyListRow.skeleton'
import RatePlansPoliciesListRowMobile from './RatePlansPoliciesListRowMobile'
import RatePlansPoliciesListTableHeadMobile from './RatePlansPoliciesListTableHeadMobile'

interface RatePlansPoliciesListMobileProps {
  data: RatePlanPolicy[] | undefined
  loading: boolean
  reloadData: () => void
}
const RatePlansPoliciesListMobile: React.FC<
  RatePlansPoliciesListMobileProps
> = ({ data, loading, reloadData }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  return (
    <>
      <div>
        <RatePlansPoliciesListTableHeadMobile reloadData={reloadData} />
      </div>
      <div>
        {loading
          ? Array(8)
              .fill('')
              .map((item, index) => (
                <PolicyRowSkeleton
                  key={`accommodation-skeleton${item}${index.toString()}`}
                />
              ))
          : data?.map((item: RatePlanPolicy) => (
              <RatePlansPoliciesListRowMobile policiesData={item} />
            ))}
      </div>
    </>
  )
}
export default RatePlansPoliciesListMobile
